var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNeutralSentimentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Leading Icon",
    clipPath: "url(#clip0_2489_5481)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M6.6665 12.5H13.3332M12.4998 7.49996H12.5082M7.49984 7.49996H7.50817M18.3332 9.99996C18.3332 14.6023 14.6022 18.3333 9.99984 18.3333C5.39746 18.3333 1.6665 14.6023 1.6665 9.99996C1.6665 5.39759 5.39746 1.66663 9.99984 1.66663C14.6022 1.66663 18.3332 5.39759 18.3332 9.99996ZM12.9165 7.49996C12.9165 7.73008 12.73 7.91663 12.4998 7.91663C12.2697 7.91663 12.0832 7.73008 12.0832 7.49996C12.0832 7.26984 12.2697 7.08329 12.4998 7.08329C12.73 7.08329 12.9165 7.26984 12.9165 7.49996ZM7.9165 7.49996C7.9165 7.73008 7.72996 7.91663 7.49984 7.91663C7.26972 7.91663 7.08317 7.73008 7.08317 7.49996C7.08317 7.26984 7.26972 7.08329 7.49984 7.08329C7.72996 7.08329 7.9165 7.26984 7.9165 7.49996Z",
    stroke: "#A6A9B2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2489_5481"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeutralSentimentIcon);
export default __webpack_public_path__ + "static/media/neutral_sentiment_icon.34b2ab6cbdc4dfd64f75ec45639e2659.svg";
export { ForwardRef as ReactComponent };